export default __webpack_public_path__ + "static/media/6.b53588a3.jpeg";